import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToursCompareService {
  #tours = {};
  constructor() {
    this.attachHandlers();
  }

  public inCompare(tourId: string) {
    return this.#tours.hasOwnProperty(tourId);
  }

  private attachHandlers() {
    window.addEventListener('ng:comparison:add', (event: CustomEvent) => {
      const tourId = event.detail.tourID;
      const rsId = event.detail.rsId;

      this.#tours[tourId] = rsId;
    });
    window.addEventListener('ng:comparison:remove', (event: CustomEvent) => {
      const id = event.detail.rsId;
      for (const tourId in this.#tours) {
        if (this.#tours.hasOwnProperty(tourId)) {
          const rsId = this.#tours[tourId];
          if (rsId === id) {
            delete this.#tours[tourId];
          }
        }
      }
    });
  }
}
